function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.8;}.cls-2,.cls-4{opacity:0.64;}.cls-3,.cls-4{fill:#fff;}.cls-5{opacity:0.21;}.cls-6,.cls-7{fill:#d4d4d4;}.cls-7{fill-rule:evenodd;opacity:0.4;}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-1"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M35.29,1.18C31.25,4.93,28,10.42,25.71,17H44.87C42.6,10.42,39.33,4.93,35.29,1.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M25.26,62.49c-.15-.39-.29-.77-.43-1.16s-.36-1.08-.53-1.63-.39-1.24-.57-1.87c-.11-.38-.21-.77-.31-1.16-.21-.8-.4-1.6-.58-2.42-.07-.31-.13-.62-.2-.93-.1-.53-.23-1-.32-1.58A22.07,22.07,0,0,0,14.4,76.23,22.83,22.83,0,0,1,26.15,64.76l-.06-.14C25.8,63.92,25.53,63.21,25.26,62.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M44.7,61.29c.31-.87.59-1.75.86-2.65.1-.32.2-.63.29-1,.21-.76.41-1.54.6-2.32.1-.44.21-.88.31-1.32.16-.73.3-1.46.44-2.2a72.11,72.11,0,0,0,1.19-12.92A68.37,68.37,0,0,0,45,17.45H25.55a68.37,68.37,0,0,0-3.36,21.48,72.36,72.36,0,0,0,1.32,13.61c.08.41.16.83.25,1.24.15.71.32,1.4.49,2.09.13.51.26,1,.4,1.54s.32,1.08.48,1.61.42,1.33.65,2l.39,1.07c.3.8.61,1.59.94,2.36s.52,1.24.81,1.84a23.83,23.83,0,0,1,14.75,0c.24-.51.45-1,.67-1.56.42-.95.81-1.93,1.18-2.93ZM35.29,36a7,7,0,1,1,7-7A7,7,0,0,1,35.29,36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M48.25,51.74c-.06.37-.15.72-.22,1.09-.11.58-.23,1.15-.36,1.72s-.26,1.09-.39,1.62-.33,1.3-.51,1.93l-.33,1.1c-.25.8-.5,1.59-.77,2.36l-.15.4c-.35.95-.71,1.89-1.09,2.8A22.9,22.9,0,0,1,56.18,76.23a22.6,22.6,0,0,0,1-6.84A22.06,22.06,0,0,0,48.25,51.74Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "30.17 75.21 30.68 75.21 32.02 69.1 31.51 69.1 30.17 75.21"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M30.77,66.59l-.67.14V68.1h.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M31.27,68.1h.92V66.34l-.92.15Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "33.42 75.21 33.92 75.21 34.37 69.1 33.87 69.1 33.42 75.21"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M33.62,66.18c-.31,0-.62.07-.93.1V68.1h.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M34.12,68.1H35v-2c-.31,0-.61,0-.92,0Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "36.22 69.1 36.66 75.21 37.16 75.21 36.72 69.1 36.22 69.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M36.46,66.16c-.3,0-.61,0-.92,0v2h.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M37,68.1h.93V66.28c-.31,0-.62-.08-.93-.1Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "38.56 69.1 39.9 75.21 40.41 75.21 39.07 69.1 38.56 69.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M39.31,66.49l-.92-.15V68.1h.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M39.81,68.1h.67V66.73l-.67-.14Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M110.06,67.57a.52.52,0,0,0,.1-.33,1.38,1.38,0,0,0-.06-.26s0,0,0,0a1.34,1.34,0,0,0-.17-.27l0,0a1.55,1.55,0,0,0-.26-.25l-.05,0a2.65,2.65,0,0,0-.39-.26,3.09,3.09,0,0,0-.67-.26h0a2.23,2.23,0,0,0-.61-.08h-.31l-.19,0-.07,0-.17.08,0,0a.47.47,0,0,0-.15.13.5.5,0,0,0-.11.3v.13a1.85,1.85,0,0,0,1,1.06A2,2,0,0,0,110.06,67.57Zm-1.74-.73-.47-.5a.12.12,0,1,1,.18-.17l.44.46,1.07.09a.11.11,0,0,1,.11.13.11.11,0,0,1-.12.11h0l-1.11-.08A.18.18,0,0,1,108.32,66.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M120.26,67.2a25.17,25.17,0,0,0-9.71-9.51,11.55,11.55,0,0,1-8.91,4.39h-.16a11.45,11.45,0,0,1-7.25-2.56l-.68.33C89.48,61.91,84,66.17,80.76,74.72l-.05.12A3.18,3.18,0,0,0,84.33,79a3.21,3.21,0,0,0,2.35-2A22.2,22.2,0,0,1,92,68.6h0c.31-.3.62-.58.94-.85a.5.5,0,1,1,.64.77c-.27.22-.52.46-.78.7l-1,12.55h5.88a.5.5,0,0,1,.5.5v2.14a.5.5,0,0,1-.5.5H96.17v4.42h1.49a.5.5,0,0,1,.5.5v7.85a4.22,4.22,0,0,0,.23-.93l1.91-12.28a2.25,2.25,0,0,1,4.37-.16l2.41,13a3.93,3.93,0,0,0,4.54,3.2,3.93,3.93,0,0,0,3.19-4.54L111.9,74.15a45.87,45.87,0,0,1-5.67.62H106a4.17,4.17,0,0,1-.09-8.33l.44,0v-.06a.3.3,0,0,1,0-.1,1.38,1.38,0,0,1,0-.2,1,1,0,0,1,.17-.33,2.19,2.19,0,0,1,2.4-.28h0a3,3,0,0,1,.41.18,3.2,3.2,0,0,1,.49.32l.12.12h0l.35,0c-.21-.29-.44-.59-.68-.89a.5.5,0,1,1,.77-.63c.38.46.72.93,1,1.35a13.79,13.79,0,0,0,1.39-.27.5.5,0,0,1,.25,1,23.16,23.16,0,0,1-2.5.45s0,0,0,0,0,.09,0,.14,0,0,0,.08v1.07a1.56,1.56,0,0,1-.23.64l-.06.06a6.48,6.48,0,0,1,.27,3.63,2.77,2.77,0,0,1-.27.72,34.63,34.63,0,0,0,8.7-2.24,2.67,2.67,0,0,0,1.45-1.65A2.83,2.83,0,0,0,120.26,67.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M105.94,67.44a3.18,3.18,0,0,0-2.66,4.81,3.14,3.14,0,0,0,2.8,1.52h.11l1.85-.12c.84-1,.75-3.14.38-4.29a4,4,0,0,1-.82-.3,2.05,2.05,0,0,1-1.25-1.62v0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M109,69.71a5.18,5.18,0,0,1,.1.61l1.07-.11a4.81,4.81,0,0,0-.14-.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M110.29,71.31l-1.1.12c0,.2,0,.41,0,.62h0l1.11-.13A5.82,5.82,0,0,0,110.29,71.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M110.29,71.06c0-.2,0-.41-.06-.61l-1.07.11c0,.2,0,.41,0,.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M110,73l-1.09.1a3.1,3.1,0,0,1-.21.45q.51,0,1-.12A1.77,1.77,0,0,0,110,73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M108.8,68.94s0,0,0,.08h0c0,.14.09.28.14.45l1-.11a2.78,2.78,0,0,0-.21-.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M110.17,72.54c0-.12,0-.24.07-.37l-1.13.13a4.78,4.78,0,0,1-.12.57l1.11-.1C110.13,72.69,110.15,72.61,110.17,72.54Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 85.1,
  y: 82.77,
  width: 12.05,
  height: 1.14
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 94.81,
  y: 84.91,
  width: 0.86,
  height: 4.42
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 85.1,
  y: 90.33,
  width: 12.05,
  height: 13.63
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 86.59,
  y: 84.91,
  width: 0.86,
  height: 4.42
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "94.31 89.33 94.31 84.91 91.52 84.91 91.15 89.33 94.31 89.33"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M90.91,50.64A10.58,10.58,0,1,0,102.75,40l0,1.46a.79.79,0,0,1-.43.71,1.3,1.3,0,0,1-.6.14,1.44,1.44,0,0,1-.74-.2.78.78,0,0,1-.4-.69l0-1.46A10.56,10.56,0,0,0,90.91,50.64Zm11-5c8.43.16,9,3.13,8.92,6.78s-4.2,7.54-9.19,7.44-9-4.14-8.9-7.79S93.09,45.51,101.93,45.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M95.15,56.08a.22.22,0,0,0,.3,0,.22.22,0,0,0,.07-.22c-.71-2.7-.77-5.25,1.64-7.65.54-.54-.23-1.48-.93-1.16-2.09.92-2.55,2.91-2.6,5.1A6.12,6.12,0,0,0,95.15,56.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M102.05,41.74a.28.28,0,0,0,.17-.28l.07-3a1.62,1.62,0,0,1-.49.08,1.91,1.91,0,0,1-.68-.12l-.07,3h0a.28.28,0,0,0,.17.25A.91.91,0,0,0,102.05,41.74Z"
})), /*#__PURE__*/React.createElement("circle", {
  className: "cls-4",
  cx: 35.29,
  cy: 28.99,
  r: 4.97
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 56.09,
  y: 82.77,
  width: 8.04,
  height: 3.16
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M84.6,105a.51.51,0,0,1-.5-.5v-1H51.42a1.86,1.86,0,0,1,0-3.72h19a.87.87,0,1,0,0-1.73H36a1.87,1.87,0,0,1,0-3.73h26a.86.86,0,1,0,0-1.72H38.17a1.86,1.86,0,0,1-1.86-1.86v-.31H19.42a.5.5,0,0,1-.5-.5v-3H16.58a.5.5,0,0,1,0-1h2.34V82.77H16.58a.5.5,0,0,1,0-1H64.13V31H48.94a74.57,74.57,0,0,1,.45,8,72.76,72.76,0,0,1-1,11.71,23.06,23.06,0,0,1,9.79,18.74,23.47,23.47,0,0,1-1.53,8.42.5.5,0,0,1-.47.33h0a.5.5,0,0,1-.46-.32A21.87,21.87,0,0,0,44,65.69c-.21.47-.41,1-.63,1.41a.51.51,0,0,1-.45.29.41.41,0,0,1-.16,0c-.43-.14-.86-.26-1.29-.37v1.52l2.57,7A.48.48,0,0,1,44,76a.49.49,0,0,1-.41.21H27a.49.49,0,0,1-.41-.21.48.48,0,0,1-.06-.46l2.57-7V67c-.43.11-.86.23-1.29.37a.49.49,0,0,1-.6-.26c-.23-.45-.43-.94-.64-1.42A21.9,21.9,0,0,0,14.81,77.81a.49.49,0,0,1-.46.32.6.6,0,0,1-.47-.33,23.5,23.5,0,0,1-1.53-8.42,23,23,0,0,1,9.8-18.74,72.85,72.85,0,0,1-1-11.71,69.36,69.36,0,0,1,3.4-21.72A41.13,41.13,0,0,0,7.51,30.83,42.16,42.16,0,0,0,5,74.83c4,7.22,10.09,13,16.22,18.58,7,6.32,18.68,29.36,51.79,20.84A70,70,0,0,0,93.93,105Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M35,66.12c-.31,0-.61,0-.92,0V68.1H35Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "32.02 69.1 31.51 69.1 30.17 75.21 30.68 75.21 32.02 69.1"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M30.1,66.73V68.1h.67V66.59Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M32.19,66.34l-.92.15V68.1h.92Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 38,
  y: 82.77,
  width: 8.04,
  height: 3.16
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 47.05,
  y: 82.77,
  width: 8.04,
  height: 3.16
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 28.96,
  y: 82.77,
  width: 8.04,
  height: 3.16
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 19.92,
  y: 82.77,
  width: 8.04,
  height: 3.16
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "34.37 69.1 33.87 69.1 33.42 75.21 33.92 75.21 34.37 69.1"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "51.63 25.58 55.29 21.92 47.97 21.92 51.63 25.58"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M48.73,29.19c0,.25.08.5.11.76h6.45l-3.66-3.66Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M48.64,28.57l2.64-2.64-3.89-3.88A66,66,0,0,1,48.64,28.57Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "60.12 25.58 63.78 21.92 56.46 21.92 60.12 25.58"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "64.13 22.27 60.47 25.93 64.13 29.59 64.13 22.27"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "56.46 29.95 63.78 29.95 60.12 26.29 56.46 29.95"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 53.12,
  y: 23.18,
  width: 5.5,
  height: 5.5,
  transform: "translate(-1.97 47.11) rotate(-45)"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M40.48,66.73l-.67-.14V68.1h.67Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M35.54,66.12v2h.92V66.16C36.16,66.14,35.85,66.12,35.54,66.12Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M37.89,66.28c-.31,0-.62-.08-.93-.1V68.1h.93Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "37.16 75.21 36.72 69.1 36.22 69.1 36.66 75.21 37.16 75.21"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "40.41 75.21 39.07 69.1 38.56 69.1 39.9 75.21 40.41 75.21"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M39.31,66.49l-.92-.15V68.1h.92Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M32.69,66.28V68.1h.93V66.18C33.31,66.2,33,66.25,32.69,66.28Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "73.16 47.74 69.5 51.4 73.16 55.06 73.16 47.74"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "73.16 56.23 69.5 59.89 73.16 63.55 73.16 56.23"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "73.16 39.25 69.5 42.91 73.16 46.57 73.16 39.25"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "73.16 30.95 72.97 30.95 69.5 34.42 73.16 38.08 73.16 30.95"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 66.39,
  y: 44.4,
  width: 5.5,
  height: 5.5,
  transform: "translate(-13.09 62.7) rotate(-45)"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "73.16 73.2 69.5 76.86 73.16 80.52 73.16 73.2"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 66.39,
  y: 61.38,
  width: 5.5,
  height: 5.5,
  transform: "translate(-25.1 67.67) rotate(-45)"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 66.39,
  y: 52.89,
  width: 5.5,
  height: 5.5,
  transform: "translate(-19.09 65.19) rotate(-45)"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 66.39,
  y: 69.87,
  width: 5.5,
  height: 5.5,
  transform: "translate(-31.1 70.16) rotate(-45)"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "65.48 29.95 72.45 29.95 68.97 26.46 65.48 29.95"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "73.16 64.72 69.5 68.38 73.16 72.03 73.16 64.72"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "65.13 29.59 68.61 26.11 65.13 22.63 65.13 29.59"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "65.13 81.77 73.16 81.77 73.16 81.23 69.14 77.22 65.13 81.23 65.13 81.77"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 65.13,
  y: 82.77,
  width: 8.06,
  height: 3.16
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "65.13 72.03 68.79 68.38 65.13 64.72 65.13 72.03"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "65.13 63.55 68.79 59.89 65.13 56.23 65.13 63.55"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "65.13 38.08 68.79 34.42 65.31 30.95 65.13 30.95 65.13 38.08"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "65.13 46.57 68.79 42.91 65.13 39.25 65.13 46.57"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "65.13 55.06 68.79 51.4 65.13 47.74 65.13 55.06"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "65.13 80.52 68.79 76.86 65.13 73.2 65.13 80.52"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M128.73,45.61c-1.58-11.83-9.91-23.14-21.51-26C96.34,17,85,21.83,73.8,20.85,65,20.08,57,15.78,48.32,14.22c-1.19-.21-2.4-.35-3.61-.45a56,56,0,0,1,2.39,7.15H64.7l.06,0a.48.48,0,0,1,.22.12l8.62,8.61a.24.24,0,0,1,.23.05.23.23,0,0,1,0,.24l.13.12a.57.57,0,0,1,.11.16.65.65,0,0,1,0,.2V81.77h1a.5.5,0,0,1,0,1h-1v3.16h1a.5.5,0,0,1,0,1h-1v3a.5.5,0,0,1-.5.5H37.31v.31a.86.86,0,0,0,.86.86H61.94a1.86,1.86,0,1,1,0,3.72H36a.87.87,0,0,0,0,1.73H70.42a1.87,1.87,0,1,1,0,3.73h-19a.86.86,0,0,0,0,1.72H84.1V89.83a.5.5,0,0,1,.5-.5h1.49V84.91H84.6a.5.5,0,0,1-.5-.5V82.27a.5.5,0,0,1,.5-.5h6.18l1-11.43a21.87,21.87,0,0,0-4.11,7A4.2,4.2,0,0,1,84.53,80a4.67,4.67,0,0,1-.83.08,4.17,4.17,0,0,1-3.93-5.55l0-.15C83.14,65.52,88.87,61.1,93.1,59l.32-.16h0a11.56,11.56,0,0,1-2.76-4.25l-1-.22a1.71,1.71,0,0,1-1.35-1.47l-.18-1.29a1.76,1.76,0,0,1,.92-1.77l.92-.47A11.53,11.53,0,0,1,100.61,39l0-.75a2,2,0,1,1,3.12-1.64,2,2,0,0,1-1,1.71l0,.72A11.52,11.52,0,0,1,113,49.75l.9.51a1.77,1.77,0,0,1,.85,1.81l-.22,1.3a1.74,1.74,0,0,1-1.41,1.41l-1,.14a11.33,11.33,0,0,1-1,1.95,26.33,26.33,0,0,1,10,9.82,3.87,3.87,0,0,1,.36,3.1,3.66,3.66,0,0,1-2,2.26A30.81,30.81,0,0,1,112.89,74l1.59,12c1.74-2.1,3.39-4.28,4.92-6.55C126.06,69.48,130.31,57.45,128.73,45.61Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "66.02 30.95 69.14 34.07 72.27 30.95 66.02 30.95"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M103.69,84.54a1.23,1.23,0,0,0-1.23-.87,1.26,1.26,0,0,0-1.18,1l-1.9,12.22a4.88,4.88,0,0,1-1.22,2.7V102a74.63,74.63,0,0,0,6.56-5.63l1-1Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 66.39,
  y: 35.92,
  width: 5.5,
  height: 5.5,
  transform: "translate(-7.09 60.21) rotate(-45)"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-5"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "90.14 89.33 90.51 84.91 87.95 84.91 87.95 89.33 90.14 89.33"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M28.32,29a7,7,0,0,1,7-7V.5c-8.06,7.22-13.58,21.74-13.6,38.43,0,10.66,2.26,20.39,6,28a24,24,0,0,1,7.64-1.28V36A7,7,0,0,1,28.32,29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M101.66,59.9c5,.1,9.12-3.8,9.19-7.44s-.49-6.62-8.92-6.78c-8.84-.17-9.1,2.78-9.17,6.43S96.66,59.81,101.66,59.9Zm-6.51-3.82a6.12,6.12,0,0,1-1.52-3.9c.05-2.19.51-4.18,2.6-5.1.7-.32,1.47.62.93,1.16-2.41,2.4-2.35,4.95-1.64,7.65a.22.22,0,0,1-.07.22A.22.22,0,0,1,95.15,56.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M121.13,66.69a26.33,26.33,0,0,0-10-9.82,11.33,11.33,0,0,0,1-1.95l1-.14a1.74,1.74,0,0,0,1.41-1.41l.22-1.3a1.77,1.77,0,0,0-.85-1.81l-.9-.51A11.52,11.52,0,0,0,102.78,39l0-.72a2,2,0,0,0,1-1.71,2,2,0,1,0-3.12,1.64l0,.75A11.53,11.53,0,0,0,90,49.33l-.92.47a1.76,1.76,0,0,0-.92,1.77l.18,1.29a1.71,1.71,0,0,0,1.35,1.47l1,.22a11.56,11.56,0,0,0,2.76,4.25h0L93.1,59c-4.23,2.14-10,6.56-13.28,15.4l0,.15a4.17,4.17,0,0,0,3.93,5.55,4.67,4.67,0,0,0,.83-.08,4.2,4.2,0,0,0,3.09-2.69,21.87,21.87,0,0,1,4.11-7l-1,11.43H84.6a.5.5,0,0,0-.5.5v2.14a.5.5,0,0,0,.5.5h1.49v4.42H84.6a.5.5,0,0,0-.5.5V102.5H51.42a.86.86,0,0,1,0-1.72h19a1.87,1.87,0,1,0,0-3.73H36a.87.87,0,0,1,0-1.73h26a1.86,1.86,0,1,0,0-3.72H38.17a.86.86,0,0,1-.86-.86v-.31H73.69a.5.5,0,0,0,.5-.5v-3h1a.5.5,0,0,0,0-1h-1V82.77h1a.5.5,0,0,0,0-1h-1V30.45a.65.65,0,0,0,0-.2.57.57,0,0,0-.11-.16L73.88,30a.23.23,0,0,0,0-.24.24.24,0,0,0-.23-.05L65,21.07a.48.48,0,0,0-.22-.12l-.06,0H47.1C44.79,12.15,40.81,4.77,35.62.13a.49.49,0,0,0-.66,0c-8.47,7.59-13.75,22.46-13.77,38.8a72.85,72.85,0,0,0,1,11.71,23,23,0,0,0-9.8,18.74,23.5,23.5,0,0,0,1.53,8.42.6.6,0,0,0,.47.33.49.49,0,0,0,.46-.32A21.9,21.9,0,0,1,26.57,65.68c.21.48.41,1,.64,1.42a.49.49,0,0,0,.6.26c.43-.14.86-.26,1.29-.37v1.52l-2.57,7a.48.48,0,0,0,.06.46.49.49,0,0,0,.41.21H43.58A.49.49,0,0,0,44,76a.48.48,0,0,0,.06-.46l-2.57-7V67c.43.11.86.23,1.29.37a.41.41,0,0,0,.16,0,.51.51,0,0,0,.45-.29c.22-.45.42-.94.63-1.41A21.87,21.87,0,0,1,55.76,77.81a.5.5,0,0,0,.46.32h0a.5.5,0,0,0,.47-.33,23.47,23.47,0,0,0,1.53-8.42,23.06,23.06,0,0,0-9.79-18.74,72.76,72.76,0,0,0,1-11.71,74.57,74.57,0,0,0-.45-8H64.13V81.77H16.58a.5.5,0,0,0,0,1h2.34v3.16H16.58a.5.5,0,0,0,0,1h2.34v3a.5.5,0,0,0,.5.5H36.31v.31a1.86,1.86,0,0,0,1.86,1.86H61.94a.86.86,0,1,1,0,1.72H36a1.87,1.87,0,0,0,0,3.73H70.42a.87.87,0,1,1,0,1.73h-19a1.86,1.86,0,0,0,0,3.72H84.1v1a.51.51,0,0,0,.5.5H97.66a.51.51,0,0,0,.5-.5V99.58a4.88,4.88,0,0,0,1.22-2.7l1.9-12.22a1.26,1.26,0,0,1,1.18-1,1.23,1.23,0,0,1,1.23.87l2.41,12.92a4.92,4.92,0,0,0,4.84,4.08,5,5,0,0,0,.85-.08,4.92,4.92,0,0,0,4-5.67L112.89,74a30.81,30.81,0,0,0,6.61-1.92,3.66,3.66,0,0,0,2-2.26A3.87,3.87,0,0,0,121.13,66.69ZM73.16,31v7.13L69.5,34.42,73,31ZM73,38.67l-3.89,3.89-3.89-3.89,3.89-3.89ZM66,31h6.25l-3.13,3.12Zm7,16.2-3.89,3.9-3.89-3.9,3.89-3.89Zm0,8.49-3.89,3.89-3.89-3.89,3.89-3.89Zm0,8.49L69.14,68l-3.89-3.89,3.89-3.89Zm0,8.49-3.89,3.89-3.89-3.89,3.89-3.89Zm.13.58v7.32L69.5,76.86ZM69.5,68.38l3.66-3.66V72Zm0-8.49,3.66-3.66v7.32Zm0-8.49,3.66-3.66v7.32Zm0-8.49,3.66-3.66v7.32Zm3-13h-7L69,26.46Zm-7.32-7.32,3.48,3.48-3.48,3.48Zm0,8.32h.18l3.48,3.47-3.66,3.66Zm0,8.3,3.66,3.66-3.66,3.66Zm0,8.49,3.66,3.66-3.66,3.66Zm0,8.49,3.66,3.66-3.66,3.66Zm0,8.49,3.66,3.66L65.13,72Zm0,8.48,3.66,3.66-3.66,3.66Zm0,8,4-4,4,4v.54h-8Zm0,1.54h8.06v3.16H65.13ZM63.78,21.92l-3.66,3.66-3.66-3.66Zm-8.49,0-3.66,3.66L48,21.92Zm-20-20.74c4,3.75,7.31,9.24,9.58,15.77H25.71C28,10.42,31.25,4.93,35.29,1.18ZM14.4,76.23a22.07,22.07,0,0,1,7.92-24.49c.09.54.22,1,.32,1.58.07.31.13.62.2.93.18.82.37,1.62.58,2.42.1.39.2.78.31,1.16.18.63.37,1.25.57,1.87s.34,1.09.53,1.63.28.77.43,1.16c.27.72.54,1.43.83,2.13l.06.14A22.83,22.83,0,0,0,14.4,76.23Zm16.28-1h-.51l1.34-6.11H32ZM30.1,68.1V66.73l.67-.14V68.1Zm2.09,0h-.92V66.49l.92-.15Zm1.73,7.11h-.5l.44-6.11h.51ZM32.69,68.1V66.28c.31,0,.62-.08.93-.1V68.1Zm2.35,0h-.92V66.16c.31,0,.61,0,.92,0Zm1.62,7.11-.44-6.11h.5l.44,6.11ZM35.54,68.1v-2c.31,0,.62,0,.92,0V68.1Zm2.35,0H37V66.18c.31,0,.62.07.93.1Zm2,7.11L38.56,69.1h.51l1.34,6.11ZM38.39,68.1V66.34l.92.15V68.1Zm2.09,0h-.67V66.59l.67.14Zm2.86-3.38c-.22.52-.43,1-.67,1.56a23.83,23.83,0,0,0-14.75,0c-.29-.6-.54-1.22-.81-1.84s-.64-1.56-.94-2.36L25.78,61c-.23-.66-.44-1.32-.65-2s-.33-1.07-.48-1.61-.27-1-.4-1.54c-.17-.69-.34-1.38-.49-2.09-.09-.41-.17-.83-.25-1.24a72.36,72.36,0,0,1-1.32-13.61,68.37,68.37,0,0,1,3.36-21.48H45a68.37,68.37,0,0,1,3.36,21.48A72.11,72.11,0,0,1,47.2,51.85c-.14.74-.28,1.47-.44,2.2-.1.44-.21.88-.31,1.32-.19.78-.39,1.56-.6,2.32-.09.32-.19.63-.29,1-.27.9-.55,1.78-.86,2.65l-.18.5C44.15,62.79,43.76,63.77,43.34,64.72Zm13.88,4.67a22.6,22.6,0,0,1-1,6.84A22.9,22.9,0,0,0,44.43,64.76c.38-.91.74-1.85,1.09-2.8l.15-.4c.27-.77.52-1.56.77-2.36l.33-1.1c.18-.63.35-1.28.51-1.93s.27-1.07.39-1.62.25-1.14.36-1.72c.07-.37.16-.72.22-1.09A22.06,22.06,0,0,1,57.22,69.39ZM47.39,22.05l3.89,3.88-2.64,2.64A66,66,0,0,0,47.39,22.05ZM48.84,30c0-.26-.08-.51-.11-.76l2.9-2.9L55.29,30Zm3.14-4L55.87,22l3.89,3.89-3.89,3.89Zm4.48,4,3.66-3.66L63.78,30Zm4-4,3.66-3.66v7.32ZM56.09,82.77h8v3.16h-8Zm-9,0h8v3.16h-8Zm-9,0h8v3.16H38ZM28,85.93h-8V82.77h8Zm9,0H29V82.77h8Zm64.05-44.49.07-3a1.91,1.91,0,0,0,.68.12,1.62,1.62,0,0,0,.49-.08l-.07,3a.28.28,0,0,1-.17.28.91.91,0,0,1-.83-.05.28.28,0,0,1-.17-.25Zm-10.14,9.2A10.56,10.56,0,0,1,100.59,40l0,1.46a.78.78,0,0,0,.4.69,1.44,1.44,0,0,0,.74.2,1.3,1.3,0,0,0,.6-.14.79.79,0,0,0,.43-.71l0-1.46A10.57,10.57,0,1,1,90.91,50.64ZM85.1,83.91V82.77H97.16v1.14Zm10.57,1v4.42h-.86V84.91Zm-1.36,0v4.42H91.15l.37-4.42Zm-3.8,0-.37,4.42H88V84.91Zm-3.06,0v4.42h-.86V84.91Zm9.71,19H85.1V90.33H97.16Zm23.37-34.47a2.67,2.67,0,0,1-1.45,1.65,34.63,34.63,0,0,1-8.7,2.24,2.77,2.77,0,0,0,.27-.72,6.48,6.48,0,0,0-.27-3.63l.06-.06a1.56,1.56,0,0,0,.23-.64V67.26s0-.05,0-.08,0-.09,0-.14,0,0,0,0a23.16,23.16,0,0,0,2.5-.45.5.5,0,0,0-.25-1,13.79,13.79,0,0,1-1.39.27c-.31-.42-.65-.89-1-1.35a.5.5,0,1,0-.77.63c.24.3.47.6.68.89l-.35,0h0L109.9,66a3.2,3.2,0,0,0-.49-.32,3,3,0,0,0-.41-.18h0a2.19,2.19,0,0,0-2.4.28,1,1,0,0,0-.17.33,1.38,1.38,0,0,0,0,.2.3.3,0,0,0,0,.1v.06l-.44,0a4.17,4.17,0,0,0,.09,8.33h.23a45.87,45.87,0,0,0,5.67-.62l2.91,21.79a3.92,3.92,0,0,1-6.12,3.88,3.87,3.87,0,0,1-1.61-2.54l-2.41-13a2.25,2.25,0,0,0-4.37.16L98.39,96.75a4.22,4.22,0,0,1-.23.93V89.83a.5.5,0,0,0-.5-.5H96.17V84.91h1.49a.5.5,0,0,0,.5-.5V82.27a.5.5,0,0,0-.5-.5H91.78l1-12.55c.26-.24.51-.48.78-.7a.5.5,0,1,0-.64-.77c-.32.27-.63.55-.94.85h0A22.2,22.2,0,0,0,86.68,77a3.15,3.15,0,0,1-4,1.93,3.16,3.16,0,0,1-1.94-4l.05-.12C84,66.17,89.48,61.91,93.55,59.85l.68-.33a11.45,11.45,0,0,0,7.25,2.56h.16a11.55,11.55,0,0,0,8.91-4.39,25.17,25.17,0,0,1,9.71,9.51A2.83,2.83,0,0,1,120.53,69.49Zm-12.93-.43a4,4,0,0,0,.82.3c.37,1.15.46,3.3-.38,4.29l-1.85.12h-.11a3.14,3.14,0,0,1-2.8-1.52,3.18,3.18,0,0,1,2.66-4.81l.41,0v0A2.05,2.05,0,0,0,107.6,69.06Zm.23-1.52a1.85,1.85,0,0,1-1-1.06v-.13a.5.5,0,0,1,.11-.3.47.47,0,0,1,.15-.13l0,0,.17-.08.07,0,.19,0h.31a2.23,2.23,0,0,1,.61.08h0a3.09,3.09,0,0,1,.67.26,2.65,2.65,0,0,1,.39.26l.05,0a1.55,1.55,0,0,1,.26.25l0,0a1.34,1.34,0,0,1,.17.27s0,0,0,0a1.38,1.38,0,0,1,.06.26.52.52,0,0,1-.1.33A2,2,0,0,1,107.83,67.54Zm1.29,2.78a5.18,5.18,0,0,0-.1-.61l1-.1a4.81,4.81,0,0,1,.14.6Zm1.11.13c0,.2,0,.41.06.61l-1.1.11c0-.2,0-.41,0-.61Zm-1.26-1c0-.17-.09-.31-.14-.45h0s0-.06,0-.08l1-.07a2.78,2.78,0,0,1,.21.49Zm-.06,3.66L110,73a1.77,1.77,0,0,1-.28.43q-.51.08-1,.12A3.1,3.1,0,0,0,108.91,73.13Zm.08-.26a4.78,4.78,0,0,0,.12-.57l1.13-.13c0,.13,0,.25-.07.37s0,.15-.07.23Zm.17-.83h0c0-.21,0-.42,0-.62l1.1-.12a5.82,5.82,0,0,1,0,.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M84.34,77.45c-.38.07-.64.31-.6.53s.39.34.76.26.65-.32.6-.54S84.72,77.37,84.34,77.45Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 95.77,
  y: 64.92,
  width: 3.25,
  height: 3.25,
  rx: 0.73,
  transform: "translate(-1.98 2.99) rotate(-1.74)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M107.85,66.16a.13.13,0,0,0,0,.18l.47.5a.18.18,0,0,0,.09,0l1.11.08h0a.11.11,0,0,0,.12-.11.11.11,0,0,0-.11-.13l-1.07-.09-.44-.46A.13.13,0,0,0,107.85,66.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M35.29,22a7,7,0,1,0,7,7A7,7,0,0,0,35.29,22Zm0,11.93a5,5,0,1,1,5-5A5,5,0,0,1,35.29,34Z"
})));

function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129.06 116.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Empty-state-illustration-v2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.dfb3897ba46b8e21cd9a7434584860fe.svg";
export { ForwardRef as ReactComponent };